"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import SignUpContent from "@/components/sections/auth/SignUpContent";
import { isAuthenticated } from "@/lib/auth";
import { useOnboarding } from "@/contexts/OnboardingContext";

export default function SignUpPage() {
	const router = useRouter();
	const [isChecking, setIsChecking] = useState(true);
	const { isOnboarded, isLoading: onboardingLoading } = useOnboarding();

	useEffect(() => {
		const checkAuth = async () => {
			// Check if user is already authenticated
			const authenticated = await isAuthenticated();
			if (authenticated) {
				// Wait for onboarding context to load
				if (onboardingLoading) {
					return;
				}

				// Check onboarding status from context
				if (isOnboarded) {
					// User is authenticated and onboarded, redirect to dashboard
					router.push("/dashboard");
					return;
				} else {
					// User is authenticated but not onboarded, redirect to onboarding
					router.push("/user/onboard");
					return;
				}
			}
			// User is not authenticated, show signup page
			setIsChecking(false);
		};

		checkAuth();
	}, [router, isOnboarded, onboardingLoading]);

	// Show loading state while checking auth
	if (isChecking) {
		return (
			<div className="min-h-screen bg-[#16251c] flex items-center justify-center">
				<div className="text-center">
					<div className="w-12 h-12 border-4 border-[#A7FF5E] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
					<p className="text-[#edffde] text-sm">Loading...</p>
				</div>
			</div>
		);
	}

	return <SignUpContent />;
}
